module.exports = __webpack_public_path__ + "static/TTNormsPro-Light-b90b4dd0fe76e879579e80666d7468eb.woff";